import {
  AnyTeamGroupEntityVersion,
  Collections,
  FirestoreEntity,
  Mapper,
  TeamGroup,
} from '@uploadcam/common';
import { CollectionReference, doc, Firestore, getDoc, updateDoc } from 'firebase/firestore';
import { getCollectionRef } from '../../../../@harmony/angular';
import { assertTeamGroupData, TeamGroupData } from './create-team-group.interactor';

export class UpdateTeamGroupInteractor {
  private readonly collection: CollectionReference<AnyTeamGroupEntityVersion>;

  constructor(
    private readonly db: Firestore,
    private readonly mapper: Mapper<FirestoreEntity<AnyTeamGroupEntityVersion>, TeamGroup>,
  ) {
    this.collection = getCollectionRef(this.db, Collections.TeamGroups);
  }

  public async execute(groupId: string, data: TeamGroupData): Promise<TeamGroup> {
    assertTeamGroupData(data);

    const docRef = doc(this.collection, groupId);

    await updateDoc(docRef, {
      ...(data.name !== undefined && { name: data.name }),
      ...(data.email !== undefined && { email: data.email }),
    });

    return this.mapper.map(FirestoreEntity.from(await getDoc(docRef)));
  }
}
